import { selectDeclType, selectProcedure, selectTransmissionTypeList } from "@EUForms/selectors";
import { createSelector } from "reselect";
import { fileTypeMapping, transmissionMapping } from "./util";

const createParameterSelector = (selector) => (_, params) => selector(params)

const getIsEntryStateParam = createParameterSelector(params => params.entryState);
const getIsCustomStateParam = createParameterSelector((params) => params.customState)

export const selectFilterTransmisisonTypeList = createSelector(
  [
    selectTransmissionTypeList,
    getIsEntryStateParam,
    selectDeclType,
    getIsCustomStateParam,
    selectProcedure
  ],
  (transmissionList, entryState, declType, customState, procedure) => {
    if (!declType || !entryState || transmissionList?.length == 0) return []
    const mapping = transmissionMapping()
    return transmissionList.filter((item) => {
      const {
        decTypes = null,
        customStates = [],
        customStatesExcept = [],
        entryStates = [],
        procedures = []
      } = mapping[item.value] || {}

      return (
        (!['EMERGENCY']?.includes(item.value) ?
          (customStates?.includes(customState) || entryStates?.includes(entryState)) :
          !customStatesExcept.includes(customState)) &&
        procedures.includes(procedure) &&
        (decTypes ? decTypes.includes(declType) : true)
      )
    })
  }
)

export const selectFileFormType = (params) => {
  const { procedure, declType='A', transmissionType, serviceType } = params
  const MAPPING = fileTypeMapping()
  for (let i = 0; i < MAPPING.length; i++) {
    if (
      MAPPING[i].SHIPMENT_TYPE.includes(serviceType)
      && MAPPING[i].PROCEDURES.includes(procedure)
      && MAPPING[i].TRANS_TYPES.includes(transmissionType)
      && MAPPING[i].DEC_TYPES.includes(declType)
    ) {
        return MAPPING[i].FORM_TYPE
    }
  }
  return ''
}
